<template>
  <div>
    <div class="simpleTabs__nav">
      <ul class="simpleTabs__links">
        <li
          v-for="(tab, ktab) in tabs"
          :key="ktab"
          class="simpleTabs__link"
          :class="{ active : activeSlide == ktab }"
          @click.prevent="changeTab(ktab)"
        >
          <a class="simpleTabs__linkLink">
            {{ tab.tabTitle }}
          </a>
        </li>
      </ul>
    </div>

    <transition
      :name="transition"
      mode="out-in"
    >
      <div
        v-if="tabs[activeSlide]"
        :key="activeSlide"
        class="simpleTabs__slide simpleTabs__slide active"
      >
        <div class="simpleTabs__slideInner">
          <ul class="simpleTabs__topics">
            <li
              v-for="(slide, kslide) in tabs[activeSlide].content.boxes"
              :key="kslide"
              class="simpleTabs__topic"
            >
              <a
                :href="slide.permalink"
                class="simpleTabs__articleLink"
              >
                <div
                  class="simpleTabs__topicImg"
                  :style="'background-image: url(' + slide.thumbnail + ')'">
                </div>
                <div class="simpleTabs__topicContent">
                  <div class="simpleTabs__topicTitle">
                    <span class="simpleTabs__topicTitleUnderline">
                      {{ slide.title }}
                    </span>
                  </div>
                  <div class="simpleTabs__authorsDate">
                    <div class="simpleTabs__authors">
                      {{ slide.authors }}
                    </div>
                    <div class="simpleTabs__date">
                      {{ slide.date }}
                    </div>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>

export default {
  props:
    {
      tabs: {
        type: Object,
        default: null,
      },
    },
  data() {
    return {
      activeSlide:          'beitrage',
      transition:           'slide-fade-right', // : 'slide-fade-left';
      slideTransitionDelay: 700, // slide transition length + some margin
    };
  },
  mounted()
  {
    // console.log('simple-slider mounted');
    this.setupSelectedTab();
  },
  methods: {
    changeTab(tab)
    {
      this.activeSlide = tab;
      this.recalculateWrapperHeight();
    },
    recalculateWrapperHeight()
    {
      setTimeout(() => {
        this.$el.style.minHeight = 'auto';
        this.$el.style.minHeight = `${this.$el.offsetHeight}px`; // height jump problem fix
      }, this.slideTransitionDelay);
    },
    setupSelectedTab()
    {
      Object.keys(this.tabs).forEach((tabKey) => {
        if (this.tabs[tabKey].active === true) {
          this.activeSlide = tabKey;
        }
      });
    },
  },
};

</script>

<style scoped lang="scss">

  // .simpleTabs {
  // }

  .slide-fade-left-enter-active,
  .slide-fade-left-leave-active,
  .slide-fade-right-enter-active,
  .slide-fade-right-leave-active {
    transition: 0.5s;
  }

  .slide-fade-left-enter-from {
    opacity: 0;
    transform: translate3d(-100px, 0, 0);
  }
  .slide-fade-left-leave-to {
    opacity: 0;
    transform: translate3d(100px, 0, 0);
  }


  .slide-fade-right-enter-from {
    opacity: 0;
    transform: translate3d(100px, 0, 0);
  }
  .slide-fade-right-leave-to {
    opacity: 0;
    transform: translate3d(-100px, 0, 0);
  }

</style>
